import type { RegistrationWaiverFields } from '@sportninja/common/types/RegistrationWaiver'
import type { WaiverStatusInput } from './resolveWaiverStatus'

/**
 * Maps the API's `waiver` object onto the waiver tag's input.
 * `isSignedFallback` is the legacy signed boolean, read only when there is no
 * waiver object.
 */
export const waiverInputFromRegistration = (
  registration: RegistrationWaiverFields | null | undefined,
  isSignedFallback?: boolean
): WaiverStatusInput => ({
  status: registration?.waiver?.status,
  evidenceLevel: registration?.waiver?.evidence_level,
  signedAt: registration?.waiver?.signed_at,
  signedByName: registration?.waiver?.signed_by_name,
  signerRelationship: registration?.waiver?.signer_relationship,
  externalReference: registration?.waiver?.external_reference,
  revokedAt: registration?.waiver?.revoked_at,
  revokedReason: registration?.waiver?.revoked_reason,
  isSignedFallback,
})
